import styled from "@emotion/styled";
import { Modal } from "@mui/material";
export const FormModal = styled(Modal)({
  "& .formModal-class": {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #000",
    p: 4,
  },
});
